module.exports = __webpack_public_path__ + "static/media/date-icon.de2be009.svg";